import { gql } from "@apollo/client";

export const GET_BRAND_ASSOCIATED_PURCHASERS_LOOKUP = gql`
  query BrandAssociatedPurchasersLookup($brandId: Int!) {
    brandAssociatedPurchasersLookup(brandId: $brandId) {
      count
      items {
        purchaserId
        purchaserKey
        purchaserName
        purchaserIsActive
        configTemplate {
          configTemplateId
          appPurchaserId
          metadata
          searchKeywords
          intelligenceFilter
          deductionTypeInvoicePatternForDiscount
          additionalFieldMapping
          discountTermAgreementDaysTolerance
          isActive
        }
      }
    }
  }
`;
